<div class="modal-header" id="equipment-history-modal-title">
    <h3 class="modal-title" id="modal-title" translate="NOTIFICATION_DETAIL_EQUIPMENTS_HISTORY_TITLE"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body pt-0" id="modal-body">
    <div class="row">
        <div class="d-flex table-header fw-bold py-2">
            <div class="col-1"></div>
            <div class="col-4" (click)="setOrderBy('history.notificationNo.value')">
                <span translate="NOTIFICATION_DETAIL_EQUIPMENTS_HISTORY_NOTIFICATION_ID"> </span>
                <span
                    class="sort-order"
                    [hidden]="orderBy !== 'history.notificationNo.value'"
                    [ngClass]="{ reverse: reverse }"
                ></span>
            </div>
            <div class="col-2" (click)="setOrderBy('history.notificationType.value')">
                <span translate="NOTIFICATION_DETAIL_EQUIPMENTS_HISTORY_NOTIFICATION_TYPE"> </span>
                <span
                    class="sort-order"
                    [hidden]="orderBy !== 'history.notificationType.value'"
                    [ngClass]="{ reverse: reverse }"
                ></span>
            </div>
            <div class="col-2" (click)="setOrderBy('history.shortText.value')">
                <span translate="NOTIFICATION_DETAIL_EQUIPMENTS_HISTORY_NOTIFICATION_SHORT_TEXT"> </span>
                <span
                    class="sort-order"
                    [hidden]="orderBy !== 'history.shortText.value'"
                    [ngClass]="{ reverse: reverse }"
                ></span>
            </div>
            <div class="col-3" (click)="setOrderBy('history.createdDate.value')">
                <span translate="NOTIFICATION_DETAIL_EQUIPMENTS_HISTORY_DATE"> </span>
                <span
                    class="sort-order"
                    [hidden]="orderBy !== 'history.createdDate.value'"
                    [ngClass]="{ reverse: reverse }"
                ></span>
            </div>
        </div>
        <div class="equipment-history-content">
            @for (
                history of model.notificationModel.historySet | orderBy: orderBy : reverse;
                track trackById($index, history)
            ) {
                <div class="table-row">
                    <pace-equipment-history-detail
                        [history]="history"
                        [notificationModel]="model.notificationModel"
                    ></pace-equipment-history-detail>
                </div>
            }
        </div>
    </div>
</div>
